import PostIcon from "@/assets/colorable/posts.svg?react";
import ReelIcon from "@/assets/colorable/reels.svg?react";
import SourceContentIcon from "@/assets/colorable/source_content.svg?react";
import StoryIcon from "@/assets/colorable/stories.svg?react";
import TiktokIcon from "@/assets/colorable/tiktok.svg?react";
import UgcIcon from "@/assets/colorable/ugc.svg?react";
import type {TContent} from "@/store/types";
import {useMemo} from "react";

type TContentIcons = {
  translationKey: string;
  Icon: typeof StoryIcon;
};

function useContentIcons<K extends TContent>(contentType: K): TContentIcons;
function useContentIcons<K extends "ALL">(contentType: K): {[key in TContent]: TContentIcons};
function useContentIcons<K extends TContent | "ALL">(contentType: K) {
  const allData = useMemo<Record<TContent, TContentIcons>>(
    () => ({
      STORY: {
        Icon: StoryIcon,
        translationKey: "story",
      },
      POST: {
        translationKey: "post",
        Icon: PostIcon,
      },
      FEED: {
        translationKey: "post",
        Icon: PostIcon,
      },
      REEL: {
        translationKey: "reel",
        Icon: ReelIcon,
      },
      REELS: {
        translationKey: "reel",
        Icon: ReelIcon,
      },
      UGC: {
        translationKey: "video",
        Icon: UgcIcon,
      },
      SOURCE: {
        translationKey: "source",
        Icon: SourceContentIcon,
      },
      INSIGHTS: {
        Icon: StoryIcon,
        translationKey: "story",
      },
      TIKTOK: {
        Icon: TiktokIcon,
        translationKey: "tiktok",
      },
    }),
    [],
  );

  if (contentType === "ALL") return allData;
  return allData[contentType as TContent];
}

export default useContentIcons;
